const teacherRepresentatives = [
    "Mrs. Rebecca James",
    "Mr. & Mrs. Abhishek Singh",
    "Mr. & Mrs. Rakesh V. J.",
    "Mrs. Seema Yadav",
    "Mrs. Shivani Jaiswal",
    "Mr. Johnson Kujur",
];


const Faculty = () => {
    return (
        <div id="faculty" className="vision-card">

            <h3 className="table-section-heading">
                FACULTY & STAFFS
            </h3>

            <div className="table-section-wrap">
                <table className="table-section faculty-table">

                    <tbody>
                        <tr>
                            <td>TOTAL NUMBER OF TEACHERS (ALL CLASSES)</td>
                            <td>75</td>
                            <td>NUMBER OF PGTs</td>
                            <td>19</td>
                        </tr>
                        <tr>
                            <td>NUMBER OF TGTs</td>
                            <td>33</td>
                            <td>NUMBER OF PRTs</td>
                            <td>23</td>
                        </tr>
                        <tr>
                            <td>NUMBER OF PETs</td>
                            <td>1</td>
                            <td>OTHER NON-TEACHING STAFF</td>
                            <td>2</td>
                        </tr>
                        <tr>
                            <td>NUMBER OF CTET/TET QUALIFIED TEACHERS</td>
                            <td>5</td>
                            <td>NUMBER OF TRAININGS ATTENDED BY TEACHERS SINCE LAST YEAR</td>
                            <td>2</td>
                        </tr>
                    </tbody>
                </table>

            </div>

            {/* Teacher Representatives */}
            <div className="vision-card">
                <h3 className="pta-heading">Teacher</h3>

                <ul className="pta-list">
                    {teacherRepresentatives.map((teacher, index) => (
                        <li key={index}>{teacher}</li>
                    ))}
                </ul>
            </div>

            <div className="table-section-wrap">
                <h2 className="pta-title">
                    Teacher
                </h2>
                <table className="table-section">
                    <thead>
                        <tr>
                            <th>SL NO</th>
                            <th>TEACHER NAME</th>
                            <th>DESIGNATION</th>
                            <th>QUALIFICATION</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr className="teacher-group">
                            <td colSpan="4">PGT Teacher</td>
                        </tr>

                        <tr><td>1</td><td>AJIT R. JAMES</td><td>PRINCIPAL</td><td>M.Com, B.Ed</td></tr>
                        <tr><td>2</td><td>REBECCA JAMES</td><td>VICE PRINCIPAL</td><td>M.A, B.Ed</td></tr>
                        <tr><td>3</td><td>ABHISHEK PRATAP SINGH</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>4</td><td>ADITYA SINGH</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>5</td><td>AJAY PRATAP SINGH</td><td>PET</td><td>M.A, M.P.Ed</td></tr>
                        <tr><td>6</td><td>ASHOK KUMAR SHUKLA</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>7</td><td>GANESH JAISWAL</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>8</td><td>K.S. VISHNU VARMA</td><td>PGT</td><td>M.C.A, B.Ed</td></tr>
                        <tr><td>9</td><td>RAHUL BHARDWAJ</td><td>PGT</td><td>B.Tech, B.Ed</td></tr>
                        <tr><td>10</td><td>RAKESH V. J.</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>11</td><td>RAM BABOO</td><td>PGT</td><td>M.Com, B.Ed</td></tr>
                        <tr><td>12</td><td>RAMESH KUMAR G</td><td>PGT</td><td>M.Com, B.Ed</td></tr>
                        <tr><td>13</td><td>RICHUMON GEORGE</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>14</td><td>SADIKH PUTHAN PURAKKAL</td><td>PGT</td><td>M.A, NET</td></tr>
                        <tr><td>15</td><td>SATYAM PANDEY</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>
                        <tr><td>16</td><td>SEEMA YADAV</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>17</td><td>SUYASH VERMA</td><td>PGT</td><td>B.Tech, B.Ed</td></tr>
                        <tr><td>18</td><td>VISHNUPRIYA G. S.</td><td>PGT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>19</td><td>VIVEK KUMAR SINGH</td><td>PGT</td><td>M.Sc, B.Ed</td></tr>

                        <tr className="teacher-group">
                            <td colSpan="4">TGT Teacher</td>
                        </tr>

                        <tr><td>1</td><td>AAKRITI JAISWAL</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>2</td><td>ABHISHEK KUMAR GUPTA</td><td>TGT</td><td>MCA, B.Ed</td></tr>
                        <tr><td>3</td><td>AKSHAYA S.</td><td>TGT</td><td>B.A., D.El.Ed</td></tr>
                        <tr><td>4</td><td>ANKITA YADAV</td><td>TGT</td><td>M.Sc., B.Ed</td></tr>
                        <tr><td>5</td><td>APARNA MISHRA</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>6</td><td>BALENDU SHEKHAR MISHRA</td><td>TGT</td><td>M.Sc., B.Ed</td></tr>
                        <tr><td>7</td><td>BRIJESH TIWARI</td><td>TGT</td><td>MCA, B.Ed</td></tr>
                        <tr><td>8</td><td>DANIEL MASIH</td><td>PTI</td><td>M.A., B.P.Ed</td></tr>
                        <tr><td>9</td><td>DIVYANSHU TIWARI</td><td>TGT</td><td>Senior Diploma In Music</td></tr>
                        <tr><td>10</td><td>INDRAJIT YADAV</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>11</td><td>JONSON KUJUR</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>12</td><td>KANAKLATA RAO</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>13</td><td>MAMATA KHARE</td><td>TGT</td><td>B.A., B.Ed</td></tr>
                        <tr><td>14</td><td>MANOJ KUMAR PANDEY</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>15</td><td>NAYAN LAKRA</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>16</td><td>NIKITA SINGH</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>17</td><td>PONKAJ KUMAR NAYAK</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>18</td><td>POONAM PANDEY</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>19</td><td>PRATIBHA PANDEY</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>20</td><td>RAVI PRATAP MALL</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>21</td><td>RIYA SRIVASTAVA</td><td>TGT</td><td>M.Sc., D.El.Ed</td></tr>
                        <tr><td>22</td><td>SANOJ BALIAR SINGH</td><td>TGT</td><td>B.Com., B.Ed</td></tr>
                        <tr><td>23</td><td>SATYA PRAKASH VISHWAKARMA</td><td>TGT</td><td>M.Sc., M.Ed</td></tr>
                        <tr><td>24</td><td>SHAILA KUSHWAHA</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>25</td><td>SHAJI C. C.</td><td>TGT</td><td>B.A., B.Ed</td></tr>
                        <tr><td>26</td><td>SHASHANK SHEKHAR SRIVASTAVA</td><td>TGT</td><td>MCA, D.El.Ed</td></tr>
                        <tr><td>27</td><td>SHIVANSH RAJ</td><td>TGT</td><td>B.Sc., B.Ed</td></tr>
                        <tr><td>28</td><td>SIMON KORCHE</td><td>TGT</td><td>B.A., B.Ed</td></tr>
                        <tr><td>29</td><td>TARKESHWAR TIWARI</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>30</td><td>VIJAY SHANKAR PRASAD</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>31</td><td>VINAY YADAV</td><td>TGT</td><td>B.Sc., B.Ed</td></tr>
                        <tr><td>32</td><td>VINCENT DUNGDUNG</td><td>TGT</td><td>M.A., B.Ed</td></tr>
                        <tr><td>33</td><td>VIPIN K.</td><td>TGT</td><td>B.A., B.Ed</td></tr>

                        <tr className="teacher-group">
                            <td colSpan="4">PRT Teacher</td>
                        </tr>

                        <tr><td>1</td><td>ABIN JOSEPH</td><td>PRT</td><td>M.Com, B.Ed</td></tr>
                        <tr><td>2</td><td>ARATI TRIPATHI</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>3</td><td>ARPITA MISHRA</td><td>PRT</td><td>B.Sc, B.Ed</td></tr>
                        <tr><td>4</td><td>AYUSHI JAISWAL</td><td>PRT</td><td>B.A, D.El.Ed</td></tr>
                        <tr><td>5</td><td>GREESHMA S</td><td>PRT</td><td>B.Sc, B.Ed</td></tr>
                        <tr><td>6</td><td>JYOTI TIWARI</td><td>PRT</td><td>B.Sc, D.El.Ed</td></tr>
                        <tr><td>7</td><td>KAMINI GUPTA</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>8</td><td>KM SHIVANI JAISWAL</td><td>PRT</td><td>M.A, D.El.Ed</td></tr>
                        <tr><td>9</td><td>NANDITA SHUKLA</td><td>PRT</td><td>B.A, B.Ed</td></tr>
                        <tr><td>10</td><td>NEHA CHAUHAN</td><td>PRT</td><td>B.A, B.Ed</td></tr>
                        <tr><td>11</td><td>NIDHI MANI TRIPATHI</td><td>PRT</td><td>D.El.Ed</td></tr>
                        <tr><td>12</td><td>PRAGATI TRIPATHI</td><td>PRT</td><td>B.A, B.Ed</td></tr>
                        <tr><td>13</td><td>PURNIMA SRIVASTAVA</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>14</td><td>PUSHPA SINGH</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>15</td><td>REKHA MISHRA</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>16</td><td>ROSHNI MISHRA</td><td>PRT</td><td>B.A, B.Ed</td></tr>
                        <tr><td>17</td><td>SACHIN KUMAR SRIVASTAVA</td><td>PRT</td><td>B.A, BCA</td></tr>
                        <tr><td>18</td><td>SANA TARANNUM</td><td>PRT</td><td>B.Sc, B.Ed</td></tr>
                        <tr><td>19</td><td>SANGITA TIWARI</td><td>PRT</td><td>M.A, D.El.Ed</td></tr>
                        <tr><td>20</td><td>SAPANA SINGH</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>21</td><td>SHUBHANGI SHAHI</td><td>PRT</td><td>M.A, B.Ed</td></tr>
                        <tr><td>22</td><td>SUKANYA RAJ R</td><td>PRT</td><td>MCA</td></tr>
                        <tr><td>23</td><td>SYLJA T.A</td><td>PRT</td><td>B.Com, B.Ed</td></tr>
                    </tbody>
                </table>
            </div>

        </div >

    );
};

export default Faculty;